import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";
import {DceAjax} from "dce-ajax";
import {CancelTokenSource} from "axios";

interface AutosizeTextareaProps {
    minHeight: number
}

@Dce("AutosizeTextarea")
export default class AutosizeTextarea extends DceComponent<AutosizeTextareaProps> {
    private padd: number;
    private border: number;
    private fontSize: number;

    constructor(elem: DceHTMLElement, props: AutosizeTextareaProps) {
        super(elem, props);

        let styles = getComputedStyle(this.elem);

        this.padd = parseInt(styles.paddingTop) + parseInt(styles.paddingBottom);
        this.fontSize = parseInt(styles.fontSize);
        this.border = parseInt(styles.borderTopWidth) + parseInt(styles.borderBottomWidth);
        console.log(styles.fontSize);

        elem.addEventListener('input', ev => {
            this.resize();
        });

        this.init()
    }

    public init(){

        let v = (this.elem as unknown as HTMLTextAreaElement).value;
        if(v == ''){
            if(this.props.minHeight) {
                this.elem.style.height = (this.props.minHeight + this.border) + 'px';
            }else{
                this.elem.style.height = '';
            }

        }else{
            this.resize();
        }
    }


    public resize() {

        this.elem.style.height = '0px';
        let sh = this.elem.scrollHeight;

        if(this.props.minHeight && sh < this.props.minHeight){
            sh = this.props.minHeight;
        }

        this.elem.style.height = (sh + this.border) + "px";

    }

}
